import React from 'react';

const Hero = () => {
  return (
    <section className="bg-gradient-to-r from-primary to-secondary py-20">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center text-white">
          <h1 className="text-5xl font-bold mb-6">
            Transforming Businesses Through Technology
          </h1>
          <p className="text-xl mb-8">
            Expert consulting services for modern software solutions
          </p>
          <a 
            href="#services"
            className="bg-white text-primary px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors"
          >
            Explore Our Services
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
